import { useCallback } from "react";
import {
  Measure,
  useMeasureOption,
} from "components/plan/table/production/ProductionContext";
import { useTenantData } from "contexts/tenant";
import { useNumberSerialiser } from "hooks/serialisers/numbers";
import { useUnitsFormatter } from "hooks/formatters";
import { recipeDecimalPlaces } from "src/constants";

const useMeasureOptionSafe = () => {
  try {
    return useMeasureOption();
  } catch {
    return Measure.Mass;
  }
};

export const useMassFormatter = () => {
  const measure = useMeasureOptionSafe();
  const { small_mass_per_mass: smallMassPerMass } = useTenantData();
  const units = useUnitsFormatter(false);
  const decimalPlaces = measure === Measure.SmallMass ? 0 : recipeDecimalPlaces;
  const { format } = useNumberSerialiser({ decimalPlaces });

  const massUnitType: "mass" | "small_mass" =
    measure === Measure.SmallMass ? "small_mass" : "mass";

  const convertMass = useCallback(
    (mass: number) =>
      measure === Measure.SmallMass ? mass * smallMassPerMass : mass,
    [measure, smallMassPerMass]
  );

  return {
    formatMass: (mass: number) =>
      `${format(convertMass(mass))}${units(massUnitType)}`,
    convertMass,
  };
};
